// extracted by css-extract-rspack-plugin
export default {"root":"Qf5jn1","indicators":"rbza5x"};